import { render } from "./InHouseForm.vue?vue&type=template&id=984e7278"
import script from "./InHouseForm.vue?vue&type=script&lang=js"
export * from "./InHouseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__